import { getDomain } from 'www/utils/get-domain';
class PlayListAPI {
    constructor() {
        this.articleID = "";
        this.artilceType = "";
        this.nextVideoIndex = 0;
    }

     callApi(buckeCollId) {
         // Hard coded Ids for the 9 sept 2021 release 
         // Please remove below code before going production
         // let buckeCollId = "35768";
         this.articleID = location.pathname.split("/")[2];
         this.artilceType = location.pathname.split("/")[1];
         if(this.articleID == "956300") {
          return Promise.resolve({
                "articles": [{
                  "title": "Implementing Rhythm Control Guidelines in AF",
                  "thumbnail": "/thumbnail_library/949694.jpg",
                  "linkUrl": "/viewarticle/949694"
                }]
              })
          }
          if(this.articleID == "949694") {
              return Promise.resolve({
                "articles": [{
                  "title": "Early Rhythm Control for Atrial Fibrillation",
                  "thumbnail": "/thumbnail_library/956300.jpg",
                  "linkUrl": "/viewarticle/956300"
                }]
              })
          }

         return $.ajax({
           // url: "//api." + getDomain() + `medscape.com/contentqueryservice/bucketRendering/getrelatedearticles?bucketCollectionId=${buckeCollId}`,
           url: "//api." + getDomain() + `medscape.com/contentmetadataservice/bucketRendering/getrelatedearticles?bucketCollectionId=${buckeCollId}`,
           type: "GET"
         });
         
     }

     createPlaylist(episodes) {
        let playlist = [];
        episodes.map((data, index) => {
          if ( data["linkUrl"].indexOf(this.articleID) >= 0) {
            playlist.push({
              "isIfi": false,
              "isPlaylist": false,
              "link": `/${this.artilceType}/${data["linkUrl"].split("/")[2]}`,
              "playlist": {
                "thumbnail": data["thumbnail"],
                "header": "",
                "title": this.enhanceTitleForViewability(data["title"])
              },
              "video": "current video"
            })
            this.nextVideoIndex = index + 1;
          } else {
            playlist.push({
              "isIfi": false,
              "isPlaylist": true,
              "link": `/${this.artilceType}/${data["linkUrl"].split("/")[2]}`,
              "playlist": {
                "thumbnail": data["thumbnail"],
                "header": "",
                "title": this.enhanceTitleForViewability(data["title"])
              },
              "video": ""
            })
          }
        });
        return playlist;
     }

     enhanceTitleForViewability(title){
      if(window.breakpoint === 1 || window.breakpoint === 2){
          let titleArr = typeof title !== "undefined" && title.length > 0 ? title.split(' ') : [];
          titleArr = titleArr.map((word) => {
              const splitLen = 9;
              // if(word.length > splitLen) word = word.match(/.{1,9}/g).join('-</br>');
              if(this.containsHTML(word)) {
                return word;
              }
            word = word.indexOf("-")>-1 ?
              (word.length > splitLen ? word.split("-").map((item,index) => item.length > 9 ? item = item.match(/.{1,9}/g).join('-</br>') : ( index ==0 ? '</br>' + item :'-</br>' + item)).join('') :  word)
              : (word.length > splitLen ? word.match(/.{1,9}/g).join('-</br>') : word)
           
              return word;
          })
          return titleArr.join(' ');
      }
      else return title;
    }

    containsHTML(str) {
      const regex = /<[^>]*>/;
      return regex.test(str);
    }

     createIndiscussionPlaylist(episodes) {
       let playlist = [];
       let nextVideo;
       let initVideo;
       let nextVideoUrl;
       let nextVideoTitle;
       episodes.forEach((data, index) => {
          const isPlayVideo = (data["linkUrl"].indexOf(this.articleID) >= 0);
          if(isPlayVideo){
              initVideo = index;
              nextVideo = index + 1;
          }
          let playListObj = {
            "isIfi": false,
            "isPlaylist": !isPlayVideo,
            "link": `/${this.artilceType}/${data["linkUrl"].split("/")[2]}`,
            "title": this.enhanceTitleForViewability(data["title"]),
            "thumbnail": data["thumbnail"],
            "playlist": {
              "thumbnail": data["thumbnail"],
              "header": "",
              "title": data["title"]
            },
            "video": ""
          }
          playlist.push(playListObj);
       });
       nextVideoUrl = playlist[nextVideo] && playlist[nextVideo]["link"] ? playlist[nextVideo]["link"] : "";
       nextVideoTitle = playlist[nextVideo] && playlist[nextVideo]["title"] ? playlist[nextVideo]["title"] : "";
       return {
         playlist,
         nextVideoUrl,
         "initIndex": initVideo,
         nextVideoTitle
       };
     }

     getNextVideoIndex() {
      return this.nextVideoIndex;
         }

}

export { PlayListAPI }